import React from "react";
import { FileText } from "lucide-react";
import PriorityPill from "./PriorityPill";
import { signalName } from "./strategyShape";
import FactsToVerifyList from "./FactsToVerifyList";

function BriefRequirementItem({ requirement, crossProviderSignals }) {
	const title = signalName(requirement.signal_id, crossProviderSignals);
	const body = requirement.instruction || requirement.topic;

	return (
		<li className="monitoring__analysis-strategy-brief-item">
			<div className="monitoring__analysis-strategy-brief-item-head">
				<span className="monitoring__analysis-strategy-brief-item-title">{title}</span>
				<div className="monitoring__analysis-strategy-brief-item-badges">
					<PriorityPill priority={requirement.importance} />
					<span className="monitoring__analysis-strategy-brief-coverage">
						{requirement.provider_coverage}/3
					</span>
				</div>
			</div>
			{body && (
				<p className="monitoring__analysis-strategy-brief-item-body mb-0">{body}</p>
			)}
		</li>
	);
}

export default function ContentBriefPanel({ rec, crossProviderSignals }) {
	const requirements = rec.content_requirements ?? [];
	const facts = rec.facts_to_verify ?? [];

	if (requirements.length === 0 && facts.length === 0) return null;

	return (
		<div className="monitoring__analysis-strategy-brief-panel">
			{requirements.length > 0 && (
				<section className="monitoring__analysis-strategy-brief-section">
					<h6 className="monitoring__analysis-strategy-brief-heading">
						<FileText size={14} aria-hidden />
						Content brief
						<span className="monitoring__analysis-strategy-brief-count">
							{requirements.length}
						</span>
					</h6>
					<ul className="monitoring__analysis-strategy-brief-list mb-0">
						{requirements.map((cr, i) => (
							<BriefRequirementItem
								key={cr.signal_id ?? i}
								requirement={cr}
								crossProviderSignals={crossProviderSignals}
							/>
						))}
					</ul>
				</section>
			)}

			{facts.length > 0 && (
				<section
					className={`monitoring__analysis-strategy-brief-section${
						requirements.length > 0
							? " monitoring__analysis-strategy-brief-section--facts"
							: ""
					}`}
				>
					<FactsToVerifyList facts={facts} />
				</section>
			)}
		</div>
	);
}
